import { SelectionItem } from '../../../../domain/selectionItem'
import { ProductFilterFormState } from './ProductFilterFormContext'
import { getProductsFilters } from './getProductsFilters'

export function getPriceFilters(
  products: SelectionItem[],
  formState: ProductFilterFormState,
  isEcommerce: boolean | undefined,
): number[] {
  const productsToFilter = getProductsFilters(products, formState, isEcommerce, 'prices')

  return productsToFilter
    .map((p) => p.priceRange?.minimum_price?.regular_price?.value)
    .filter((price) => price !== undefined)
    .map((price) => price ?? 0)
}
